<template>
    <div>
        <ul class="list-unstyled" v-bind:class="[isActive ? 'up' : 'down']">
            <li><a href="https://diu.ac/" target="_blank" id="">DIU Home</a></li>
            <li><router-link @click.native="navClassHandeler" to="/" exact>Home</router-link></li>
            <li><router-link @click.native="navClassHandeler" to="/executive">Executive</router-link></li>
            <li><router-link @click.native="navClassHandeler" to="/faculty">Faculty</router-link></li>
            <li><router-link @click.native="navClassHandeler" to="/officers">Officer</router-link></li>
            <li><router-link @click.native="navClassHandeler" to="/staff">Staff</router-link></li>
        </ul>
        <a class="toggle_drawer" href="javaScript:;" @click="toggleClass()">
            <span>Menus</span>
            <i class="fa " v-bind:class="[isActive ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
        </a>
    </div>
</template>

<script>
export default {
    data () {
        return {
            isActive: false
        }
    },
    name: 'App',
    methods: {
        toggleClass(event)
        {

            if(this.isActive){
                this.isActive = false;
            }else{
                this.isActive = true;
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/HomeSidebar.vue